// @ts-nocheck
import { useMemo, memo } from 'react'
import CountUp from 'react-countup'
import { Text } from 'uikit'
import { formatBigNumberToFixed } from 'utils/formatBalance'
import styled from 'styled-components'
import { BigNumber } from '@ethersproject/bignumber'
import { useResponsive } from 'hooks/useResponse'

const Price = styled(Text)`
  justify-self: start;
  width: 70px;
  color: #666666;
  ${({ theme }) => theme.mediaQueries.lg} {
    text-align: center;
    width: auto;
  }
`

interface LabelPriceProps {
  price: BigNumber
}

const LabelPrice: React.FC<React.PropsWithChildren<LabelPriceProps>> = ({ price }) => {
  const priceAsNumber = useMemo(() => parseFloat(formatBigNumberToFixed(price, 2, 8)), [price])
  const { isMobile } = useResponsive()

  if (!Number.isFinite(priceAsNumber)) {
    return null
  }

  return (
    <CountUp start={0} preserveValue delay={0} end={priceAsNumber} prefix="$" decimals={2} duration={1}>
      {({ countUpRef }) => (
        <Price fontSize={isMobile ? '12px' : '16px'} bold mr={isMobile ? '0px' : '8px'}>
          <span ref={countUpRef} />
        </Price>
      )}
    </CountUp>
  )
}

export default memo(LabelPrice)
